// *****配货端客户端模块
export default [
  {
    path: "/replenishment",
    name: "Replenishment",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/Replenishment"),
  },
  {
    path: "/replenishmentShare",
    name: "ReplenishmentShare",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: false,
    },
    component: () => import("@pages/replenishmentClient/Replenishment"),
  },
  {
    path: "/replenishmentOrder",
    name: "ReplenishmentOrder",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentOrder"),
  },
  {
    path: "/replenishmentOrderDetail",
    name: "ReplenishmentOrderDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentOrderDetail"),
  },
  {
    path: "/orderSuccess",
    name: "OrderSuccess",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/OrderSuccess"),
  },
  {
    path: "/replenishmentFavorite",
    name: "ReplenishmentFavorite",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentFavorite"),
  },
  {
    path: "/replenishmentMessageList",
    name: "ReplenishmentMessageList",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentMessageList"),
  },
  {
    path: "/replenishmentMessageDetail",
    name: "ReplenishmentMessageDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentMessageDetail"),
  },
  {
    path: "/replenishmentMine",
    name: "ReplenishmentMine",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/replenishmentClient/ReplenishmentMine"),
  },
];
